import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EditDialogComponent } from '../../../core/components/editDialog/editDialogComponent';
import { EditDialogInstance } from '../../../core/components/editDialog/editDialogService';
import { CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { Apollo } from 'apollo-angular';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { Tour } from 'src/app/tour-planning/shared/entities/tour';
import * as fromGraphQl from './graphql';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "app-finish-tour-dialog",
  templateUrl: "finish-tour-dialog.html",
  styleUrls: ["./finish-tour-dialog.scss"]
})
export class FinishTourDialogComponent implements EditDialogInstance {
  
  finishTourForm: FormGroup;
  commandTemplate: CommandTemplate

  tour: Tour | undefined;
  minDate: Date | undefined;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: FormBuilder,
    private apollo: Apollo
  ) {
    this.commandTemplate = this.config?.data.commandTemplate;

    let tourId =this.commandTemplate?.parameters?.filter(
      parameter => parameter.name === 'commandProviderId'
    )?.[0]?.value;

    // load the tour
    if(tourId) {
      this.apollo.query<fromGraphQl.TourQueryResponse>({
        query: fromGraphQl.TOUR_QUERY,
        variables: {
          id: tourId
        },
        fetchPolicy: 'network-only',
      })
      .pipe(take(1))
      .subscribe( result => {
        this.tour = new Tour(result.data.getTour);
        if (this.tour.actualDepartureDateTime) {
          this.minDate = new Date(this.tour.actualDepartureDateTime);
        }
      })
    }

    this.finishTourForm = new FormGroup({});
    this.finishTourForm.addControl('actualArrivalDateTime', new FormControl());

  }

  getEditForm(): FormGroup {
    return this.finishTourForm;
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close({
      // this.finishTourForm.get('actualArrivalDateTime')?.value is a Date,
      // convert it to ISO string
      "actualArrivalDateTime" : this.finishTourForm.get('actualArrivalDateTime')?.value ?
        this.finishTourForm.get('actualArrivalDateTime')?.value.toISOString() :
        undefined
    });
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

}
